import { render, staticRenderFns } from "./PromotionViewPage.vue?vue&type=template&id=37ecffc9&scoped=true&"
import script from "./PromotionViewPage.vue?vue&type=script&lang=ts&"
export * from "./PromotionViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionViewPage.vue?vue&type=style&index=0&id=37ecffc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ecffc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VSimpleTable})
